import { queryOptions } from "@tanstack/react-query";
import type { CreativeFlagDto } from "@nexus/contracts";
import { fetchCreativeFlags } from "@/features/opportunities/api/creative-flags.api";

// ─── Query Keys ──────────────────────────────────────────────────────

export const creativeFlagKeys = {
  all: ["creative-flags"] as const,
  byHash: (hash: string) => ["creative-flags", hash] as const,
};

// ─── Query Options ───────────────────────────────────────────────────

/**
 * Flags for a given creative hash. Only runs when `enabled` (e.g. the view
 * dialog is open) and the hash is non-empty.
 */
export function creativeFlagsQueryOptions(creativeHash: string, enabled = true) {
  return queryOptions<CreativeFlagDto[], Error>({
    queryKey: creativeFlagKeys.byHash(creativeHash),
    queryFn: () => fetchCreativeFlags(creativeHash),
    enabled: enabled && !!creativeHash,
  });
}
